import {css} from '@emotion/react';
import styled from '@emotion/styled';

export const Wrapper = styled.div(
  ({theme}) => css`
    display: flex;
    position: relative;
    align-items: center;
    gap: 12px;

    ${theme.respondUpTo(
      'md',
      css`
        gap: 4px;
      `
    )};
  `
);
